import { useEffect } from 'react';
import { useAuth } from '@clerk/react';
import { setAuthTokenGetter } from '../lib/api';
import { setMediaTokenGetter } from '../lib/mediaCache';

// Installs Clerk's getToken as the API client's Authorization provider and
// also as the media blob-fetcher's token provider.
export function ApiAuthBridge() {
  const { getToken, isLoaded } = useAuth();

  useEffect(() => {
    if (!isLoaded) return;
    const getter = () => getToken();
    setAuthTokenGetter(getter);
    setMediaTokenGetter(getter);
    return () => {
      setAuthTokenGetter(null);
      setMediaTokenGetter(null);
    };
  }, [isLoaded, getToken]);

  return null;
}
